module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1032-bcadf5b5fb1b5978d46def5df7d328f5.png";